import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { LanguageService } from 'src/app/services/language.service';
import { isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';

/* const ADMIN = JSON.parse(localStorage.getItem('user')).is_admin;
const USER = JSON.parse(localStorage.getItem('user')).is_user; */

@Component({
  selector: 'public-header-component',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class PublicHeaderComponent implements OnInit {
  constructor(private authService: AuthService,
    protected router: Router,
    private languageService: LanguageService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }
  public environment = environment;
  public isCollapsed: boolean = true;
  public isSubMenuCollapsed: boolean = true;
  public locale: string = this.languageService.getLanguage();
  public mobile: boolean = false;
 

  ngOnInit() {
    if (isPlatformBrowser(this.platformId) && window.innerWidth < 968) {
      this.mobile = true;
    }
  }
}
